import api from "./client";

export const reportesApi = {
  getSales: (params) => api.get("/reportes/ventas/", { params }),
};



